/**
 * A little “paper” calendar with two rings and a big day-number in the middle.
 */
export function NumberedCalendarIcon({
  day = 3,
  size = 66,
  onClick,
  className,
}) {
  const dayText = String(day).padStart(2, "+");

  return (
    <button
      onClick={onClick}
      className={`inline-block p-0 ${className}`}
      style={{ width: size, height: size * 1.1 }}
    >
      <svg
        viewBox="0 0 64 64"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        className="rounded-md shadow"
      >
        {/* Outer border */}
        <rect
          width="64"
          height="64"
          rx="8"
          ry="8"
          fill="#ffffff"
          stroke="#ccc"
        />

        {/* Top red header */}
        <rect width="64" height="16" fill="#e53935" />

        {/* Binding rings */}
        <circle cx="16" cy="8" r="3" fill="#333" />
        <circle cx="48" cy="8" r="3" fill="#333" />

        {/* Day number */}
        <text
          x="50%"
          y="46"
          textAnchor="middle"
          fontSize="28"
          fontWeight="700"
          fill="#333"
          fontFamily="Arial, sans-serif"
        >
          {dayText}
        </text>
      </svg>
    </button>
  );
}

/**
 * A simple calendar outline you can use as a “pick date range” button.
 */
export function RangeCalendarIcon({ size = 66, onClick, className }) {
  return (
    <button
      onClick={onClick}
      className={`inline-block p-0 ${className}`}
      style={{ width: size, height: size * 1.1 }}
    >
      <svg
        viewBox="0 0 64 64"
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        className="rounded-md shadow"
      >
        {/* Outer border */}
        <rect
          width="64"
          height="64"
          rx="8"
          ry="8"
          fill="#ffffff"
          stroke="#ccc"
        />

        {/* Top red header */}
        <rect width="64" height="16" fill="#e53935" />

        {/* Binding rings */}
        <circle cx="10" cy="8" r="2" fill="#333" />
        <circle cx="22" cy="8" r="2" fill="#333" />
        <circle cx="34" cy="8" r="2" fill="#333" />
        <circle cx="46" cy="8" r="2" fill="#333" />
        <circle cx="58" cy="8" r="2" fill="#333" />

        {/* Calendar grid */}
        {[...Array(5)].map((_, row) =>
          [...Array(7)].map((_, col) => (
            <rect
              key={`${row}-${col}`}
              x={6 + col * 8}
              y={20 + row * 8}
              width="6"
              height="6"
              rx="1"
              fill="#ccc"
            />
          ))
        )}
      </svg>
    </button>
  );
}
